<template>
  <div v-cloak v-cloak v-loading.fullscreen.lock="dataLoading"
       element-loading-text="Loading, please wait..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">

    <el-dialog
      title="Create User"
      :visible.sync="addUserDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      width="500px"
      size="small">

      <el-form
        label-position="left"
        label-width="130px"
      >
        <el-form-item label="EBP Username: " required>
          <el-input v-model="userDTO.ebpUserName" size="small"></el-input>
        </el-form-item>
        <el-form-item label="Name CN: " required>
          <el-input v-model="userDTO.nameCn" size="small"></el-input>
        </el-form-item>
        <el-form-item label="Name EN: " required>
          <el-input v-model="userDTO.nameEn" size="small"></el-input>
        </el-form-item>
        <el-form-item label="Email: " required>
          <el-input v-model="userDTO.email" size="small"></el-input>
        </el-form-item>
        <el-form-item label="Enable: " required>
          <el-switch
            v-model="userDTO.enabled"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="true"
            :inactive-value="false"
          >
          </el-switch>
        </el-form-item>
        <el-row>
          <el-col :span=12>
            <el-form-item label="CaseSwitch: " required>
              <el-switch
                v-model="Switch.CaseSwitch"
                :disabled="controlCaseSwitchEditStatus"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="true"
                :inactive-value="false"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span=12>
            <el-form-item label="EmailSwitch: " required>
              <el-switch
                v-model="Switch.EmailSwitch"
                :disabled="controlEmailSwitchEditStatus||CaseSwitchControlEmailSwitchDisable"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="true"
                :inactive-value="false"
              >
              </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
              <el-button type="success" @click="saveUser" :loading="saveLoading">Save</el-button>
              <el-button @click="addUserDialogVisible = false">Close</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

  export default {
    components: {},
    data() {
      return {
        addUserDialogVisible: false,
        Switch:{
          CaseSwitch:true,
          EmailSwitch:true
        },
        switchDisableStatus:{
          CaseSwitchDisable:true,
          EmailSwitchDisable:true
        },
        userDTO: {
          enabled: true,
          appKey: this.appKey
        },
        dataLoading: false,
        saveLoading: false
      }
    },
    computed: {
      controlCaseSwitchEditStatus(){
        if(this.userDTO.enabled){
          this.switchDisableStatus.CaseSwitchDisable=false
          this.switchDisableStatus.EmailSwitchDisable=false
        }else{
          this.switchDisableStatus.CaseSwitchDisable=true
          this.switchDisableStatus.EmailSwitchDisable=true
          this.Switch.CaseSwitch=false
          this.Switch.EmailSwitch=false
        }
        console.log(this.userDTO.enabled)
        return this.switchDisableStatus.CaseSwitchDisable
      },
      controlEmailSwitchEditStatus(){
        if(this.userDTO.enabled){
          this.switchDisableStatus.CaseSwitchDisable=false
          this.switchDisableStatus.EmailSwitchDisable=false
        }else{
          this.switchDisableStatus.CaseSwitchDisable=true
          this.switchDisableStatus.EmailSwitchDisable=true
        }
        return this.switchDisableStatus.EmailSwitchDisable
      },
      CaseSwitchControlEmailSwitchDisable(){
        if(!this.Switch.CaseSwitch){
          this.Switch.EmailSwitch=false
          return true
        }else{
          return false
        }
      }
    },
    created() {
    },
    methods: {
      showAddUserDialog() {
        this.userDTO = {enabled: true, appKey: this.appKey};
        this.addUserDialogVisible = true;
      },
      hideAddUserDialog() {
        this.userDTO = {enabled: true};
        this.addUserDialogVisible = false;
      },
      saveUser() {
        if (this.validateUser(this.userDTO)) {

          let url = this.baseAcsUrl + '/acs/user/add-users';
          this.dataLoading = true;
          this.userDTO.emailEnable=this.Switch.EmailSwitch
          this.userDTO.caseEnable=this.Switch.CaseSwitch
          console.log(this.userDTO)
          this.saveLoading = true
          // return 
          this.http.post(url, [this.userDTO]).then(resp => {
            this.$message.success('Successful operation ');
            this.saveLoading = false
            this.addUserDialogVisible = false;
            this.dataLoading = false;
            this.$emit("saveSuccess");
          }).catch(error => {
            this.saveLoading = false
            this.dataLoading = false;
            console.info(error);
            this.$emit("saveFail");
            this.$message.warning('Operation failure');
          });
        }
      },
      validateUser(user) {
        if (!user.ebpUserName) {
          this.$message.warning('Please input EBP Username');
          return false;
        }
        if (!user.nameCn) {
          this.$message.warning('Please input Name CN');
          return false;
        }
        if (!user.nameEn) {
          this.$message.warning('Please input Name EN');
          return false;
        }

        if (!user.email) {
          this.$message.warning('Please input Email');
          return false;
        }

        let email = user.email;
        let reg = /^[a-zA-Z0-9_-][a-zA-Z0-9_.-]*@[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)+$/;
        if (!reg.test(email)) { //正则验证不通过，格式不对
          this.$message.warning('Please input valid Email');
          return false;
        }
        return true;
      }
    }
  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }

  .breadcrumb {
    background-color: transparent !important;
    margin-bottom: 0px;
  }

  .title {
    margin-left: 16px;
    font-size: 20px;
  }

  .el-form-item /deep/ .el-select {
    display: inline-block;
    width: 86%;
  }

  .add-banner-group /deep/ .el-form-item__label {
    width: 148px !important;
  }

  .add-banner-group /deep/ .el-form-item__content {
    margin-left: 148px !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/acs/user/dialog/add_user.vue